import { FETCH_ORGANIZATION_FAILURE } from './../containers/organizations/organizations.types'
import { Actions } from './shared.actions'
import { fromJS } from 'immutable'
import * as SharedTypes from './shared.types'

export const initialState = fromJS({
  searchStreets: {
    isLoading: false,
    data: [],
  },
  searchGisStreets: {
    isLoading: false,
    data: [],
  },
  searchCommunities: {
    isLoading: false,
    data: [],
  },
  searchContactTypes: {
    isLoading: false,
    data: [],
  },
  searchContactTitles: {
    isLoading: false,
    data: [],
  },
  searchPaymentPurposes: {
    isLoading: false,
    data: [],
  },
  searchOrganizations: {
    isLoading: false,
    data: [],
  },
  searchIndustries: {
    isLoading: false,
    data: [],
  },
  searchFinancialInstitutions: {
    isLoading: false,
    data: [],
  },
  imageTypes: {
    isLoading: false,
    data: [],
  },
  switchableDataCycles: {
    isLoading: false,
    data: [],
  },
  roundFactors: {
    isLoading: false,
    data: [],
  },
  areaRounding: {
    isLoading: false,
    data: [],
  },
  searchWards: {
    isLoading: false,
    data: [],
  },
  detectWardByCoordinate: {
    isLoading: false,
    data: null,
  },
  searchTypes: {
    isLoading: false,
    data: [],
  },
  wards: {
    isLoading: false,
    data: [],
  },
  discountGroups: {
    isLoading: false,
    data: [],
  },
  assessableTypes: {
    isLoading: false,
    data: [],
  },
  propertyStatuses: {
    isLoading: false,
    data: [],
  },
  businessSubcategoryTypes: {
    isLoading: false,
    data: [],
  },
  businessSubcategoryCalculationTypes: {
    isLoading: false,
    data: [],
  },
  exportListData: {
    isLoading: false,
  },
  activeLayers: {
    isLoading: false,
    data: [],
  },
  detectLayer: {
    isLoading: false,
    data: {
      layerId: null,
      id: null,
    },
  },
  detectAllLayers: {
    isLoading: false,
    data: [],
  },
  organizations: {
    isLoading: false,
    data: [],
  },
  businessCategories: {
    isLoading: false,
    data: [],
  },
  contacts: {
    isLoading: false,
    data: [],
  },
  contactTitles: {
    isLoading: false,
    data: [],
  },
  forms: {
    isLoading: false,
    data: [],
  },
  layerFeatures: {
    isLoading: false,
    data: [],
  },
  staticTemplate: {
    isLoading: false,
    data: {},
  },
  mobileTaskTypes: {
    isLoading: false,
    data: [],
  },
  acceptTermsOfService: {
    isLoading: false,
    data: null,
  },
  templateTypes: {
    isLoading: false,
    data: [],
  },
  auditLogTypes: {
    isLoading: false,
    data: [],
  },
  propertyTypesByCode: {
    isLoading: false,
    data: [],
  },
  licenseTypes: {
    isLoading: false,
    data: [],
  },
  propertyTypes: {
    isLoading: false,
    data: [],
  },
  mobileUserModes: {
    isLoading: false,
    data: [],
  },

  postprocessorSlotTypes: {
    isLoading: false,
    data: [],
  },

  documentTypes: {
    isLoading: false,
    data: [],
  },
})

export function sharedReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case SharedTypes.EXPORT_LIST_DATA_REQUEST: {
      return state.setIn(['exportListData', 'isLoading'], true)
    }

    case SharedTypes.EXPORT_LIST_DATA_SUCCESS: {
      return state.setIn(['exportListData', 'isLoading'], false)
    }

    case SharedTypes.EXPORT_LIST_DATA_FAILURE: {
      return state.setIn(['exportListData', 'isLoading'], false)
    }

    case SharedTypes.FETCH_IMAGE_TYPES_REQUEST: {
      return state.setIn(['imageTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_IMAGE_TYPES_SUCCESS: {
      return state
        .setIn(['imageTypes', 'isLoading'], false)
        .setIn(['imageTypes', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_IMAGE_TYPES_FAILURE: {
      return state.setIn(['imageTypes', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_STREETS_REQUEST: {
      return state.setIn(['searchStreets', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_STREETS_SUCCESS: {
      return state
        .setIn(['searchStreets', 'isLoading'], false)
        .setIn(['searchStreets', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_STREETS_FAILURE: {
      return state.setIn(['searchStreets', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_GIS_STREETS_REQUEST: {
      return state.setIn(['searchGisStreets', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_GIS_STREETS_SUCCESS: {
      return state
        .setIn(['searchGisStreets', 'isLoading'], false)
        .setIn(['searchGisStreets', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_GIS_STREETS_FAILURE: {
      return state.setIn(['searchGisStreets', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_COMMUNITIES_REQUEST: {
      return state.setIn(['searchCommunities', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_COMMUNITIES_SUCCESS: {
      return state
        .setIn(['searchCommunities', 'isLoading'], false)
        .setIn(['searchCommunities', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_COMMUNITIES_FAILURE: {
      return state.setIn(['searchCommunities', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_CONTACT_TYPES_REQUEST: {
      return state.setIn(['searchContactTypes', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_CONTACT_TYPES_SUCCESS: {
      return state
        .setIn(['searchContactTypes', 'isLoading'], false)
        .setIn(['searchContactTypes', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_CONTACT_TYPES_FAILURE: {
      return state.setIn(['searchContactTypes', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_CONTACT_TITLES_REQUEST: {
      return state.setIn(['searchContactTitles', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_CONTACT_TITLES_SUCCESS: {
      return state
        .setIn(['searchContactTitles', 'isLoading'], false)
        .setIn(['searchContactTitles', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_CONTACT_TITLES_FAILURE: {
      return state.setIn(['searchContactTitles', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_PAYMENT_PURPOSES_REQUEST: {
      return state.setIn(['searchPaymentPurposes', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_PAYMENT_PURPOSES_SUCCESS: {
      return state
        .setIn(['searchPaymentPurposes', 'isLoading'], false)
        .setIn(['searchPaymentPurposes', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_PAYMENT_PURPOSES_FAILURE: {
      return state.setIn(['searchPaymentPurposes', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_ORGANIZATION_REQUEST: {
      return state.setIn(['searchOrganizations', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_ORGANIZATION_SUCCESS: {
      return state
        .setIn(['searchOrganizations', 'isLoading'], false)
        .setIn(['searchOrganizations', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_ORGANIZATION_FAILURE: {
      return state.setIn(['searchOrganizations', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_INDUSTRY_REQUEST: {
      return state.setIn(['searchIndustries', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_INDUSTRY_SUCCESS: {
      return state
        .setIn(['searchIndustries', 'isLoading'], false)
        .setIn(['searchIndustries', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_INDUSTRY_FAILURE: {
      return state.setIn(['searchIndustries', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_FINANCIAL_INSTITUTION_REQUEST: {
      return state.setIn(['searchFinancialInstitutions', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_FINANCIAL_INSTITUTION_SUCCESS: {
      return state
        .setIn(['searchFinancialInstitutions', 'isLoading'], false)
        .setIn(['searchFinancialInstitutions', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_FINANCIAL_INSTITUTION_FAILURE: {
      return state.setIn(['searchFinancialInstitutions', 'isLoading'], false)
    }

    case SharedTypes.FETCH_SWITCHABLE_DATA_CYCLES_REQUEST: {
      return state.setIn(['switchableDataCycles', 'isLoading'], true)
    }

    case SharedTypes.FETCH_SWITCHABLE_DATA_CYCLES_SUCCESS: {
      return state
        .setIn(['switchableDataCycles', 'isLoading'], false)
        .setIn(['switchableDataCycles', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_SWITCHABLE_DATA_CYCLES_FAILURE: {
      return state.setIn(['switchableDataCycles', 'isLoading'], false)
    }

    case SharedTypes.FETCH_ROUND_FACTORS_REQUEST: {
      return state.setIn(['roundFactors', 'isLoading'], true)
    }

    case SharedTypes.FETCH_ROUND_FACTORS_SUCCESS: {
      return state
        .setIn(['roundFactors', 'isLoading'], false)
        .setIn(['roundFactors', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_ROUND_FACTORS_FAILURE: {
      return state.setIn(['roundFactors', 'isLoading'], false)
    }

    case SharedTypes.FETCH_AREA_ROUNDING_REQUEST: {
      return state.setIn(['areaRounding', 'isLoading'], true)
    }

    case SharedTypes.FETCH_AREA_ROUNDING_SUCCESS: {
      return state
        .setIn(['areaRounding', 'isLoading'], false)
        .setIn(['areaRounding', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_AREA_ROUNDING_FAILURE: {
      return state.setIn(['areaRounding', 'isLoading'], false)
    }

    case SharedTypes.SEARCH_WARDS_REQUEST: {
      return state.setIn(['searchWards', 'isLoading'], true)
    }

    case SharedTypes.SEARCH_WARDS_SUCCESS: {
      return state
        .setIn(['searchWards', 'isLoading'], false)
        .setIn(['searchWards', 'data'], fromJS(action.payload))
    }

    case SharedTypes.SEARCH_WARDS_FAILURE: {
      return state.setIn(['searchWards', 'isLoading'], false)
    }

    case SharedTypes.FETCH_DISCOUNT_GROUPS_REQUEST: {
      return state.setIn(['discountGroups', 'isLoading'], true)
    }

    case SharedTypes.FETCH_DISCOUNT_GROUPS_SUCCESS: {
      return state
        .setIn(['discountGroups', 'isLoading'], false)
        .setIn(['discountGroups', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_DISCOUNT_GROUPS_FAILURE: {
      return state.setIn(['discountGroups', 'isLoading'], false)
    }

    case SharedTypes.FETCH_ASSESSABLE_TYPES_REQUEST: {
      return state.setIn(['assessableTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_ASSESSABLE_TYPES_SUCCESS: {
      return state
        .setIn(['assessableTypes', 'isLoading'], false)
        .setIn(['assessableTypes', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_ASSESSABLE_TYPES_FAILURE: {
      return state.setIn(['assessableTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_PROPERTY_STATUSES_REQUEST: {
      return state.setIn(['propertyStatuses', 'isLoading'], true)
    }

    case SharedTypes.FETCH_PROPERTY_STATUSES_SUCCESS: {
      return state
        .setIn(['propertyStatuses', 'isLoading'], false)
        .setIn(['propertyStatuses', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_PROPERTY_STATUSES_FAILURE: {
      return state.setIn(['propertyStatuses', 'isLoading'], false)
    }

    case SharedTypes.DETECT_WARD_BY_COORDINATE_REQUEST: {
      return state.setIn(['detectWardByCoordinate', 'isLoading'], true)
    }

    case SharedTypes.DETECT_WARD_BY_COORDINATE_SUCCESS: {
      return state
        .setIn(['detectWardByCoordinate', 'isLoading'], false)
        .setIn(['detectWardByCoordinate', 'data'], fromJS(action.payload))
    }

    case SharedTypes.DETECT_WARD_BY_COORDINATE_FAILURE: {
      return state.setIn(['detectWardByCoordinate', 'isLoading'], false)
    }

    case SharedTypes.FETCH_SEARCH_TYPES_REQUEST: {
      return state.setIn(['searchTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_SEARCH_TYPES_SUCCESS: {
      return state
        .setIn(['searchTypes', 'isLoading'], false)
        .setIn(['searchTypes', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_SEARCH_TYPES_FAILURE: {
      return state.setIn(['searchTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_WARDS_REQUEST: {
      return state.setIn(['wards', 'isLoading'], true)
    }

    case SharedTypes.FETCH_WARDS_SUCCESS: {
      return state
        .setIn(['wards', 'isLoading'], false)
        .setIn(['wards', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_BUSINESS_SUBCATEGORY_TYPE_SUCCESS: {
      return state
        .setIn(['businessSubcategoryTypes', 'isLoading'], false)
        .setIn(['businessSubcategoryTypes', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_SUCCESS: {
      return state
        .setIn(['businessSubcategoryCalculationTypes', 'isLoading'], false)
        .setIn(
          ['businessSubcategoryCalculationTypes', 'data'],
          fromJS(action.payload),
        )
    }

    case SharedTypes.FETCH_ACTIVE_LAYERS_REQUEST: {
      return state.setIn(['activeLayers', 'isLoading'], true)
    }

    case SharedTypes.FETCH_ACTIVE_LAYERS_SUCCESS: {
      return state
        .setIn(['activeLayers', 'isLoading'], false)
        .setIn(['activeLayers', 'data'], fromJS(action.payload))
    }

    case SharedTypes.FETCH_ACTIVE_LAYERS_FAILURE: {
      return state.setIn(['activeLayers', 'isLoading'], false)
    }

    case SharedTypes.DETECT_LAYER_REQUEST: {
      return state
        .setIn(['detectLayer', 'isLoading'], true)
        .setIn(['detectLayer', 'data', 'layerId'], action.payload.id)
    }

    case SharedTypes.DETECT_LAYER_SUCCESS: {
      return state
        .setIn(['detectLayer', 'isLoading'], false)
        .setIn(['detectLayer', 'data', 'id'], action.payload.featureId)
    }

    case SharedTypes.DETECT_LAYER_FAILURE: {
      return state.setIn(['detectLayer', 'isLoading'], false)
    }

    case SharedTypes.DETECT_ALL_LAYERS_REQUEST: {
      return state.setIn(['detectAllLayers', 'isLoading'], true)
    }

    case SharedTypes.DETECT_ALL_LAYERS_SUCCESS: {
      return state
        .setIn(['detectAllLayers', 'isLoading'], false)
        .setIn(['detectAllLayers', 'data'], fromJS(action.payload))
    }

    case SharedTypes.DETECT_ALL_LAYERS_FAILURE: {
      return state.setIn(['detectAllLayers', 'isLoading'], false)
    }

    case SharedTypes.FETCH_ORGANIZATIONS_REQUEST: {
      return state.setIn(['organizations', 'isLoading'], true)
    }

    case SharedTypes.FETCH_ORGANIZATIONS_SUCCESS: {
      return state
        .setIn(['organizations', 'isLoading'], false)
        .setIn(['organizations', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_ORGANIZATIONS_FAILURE: {
      return state.setIn(['organizations', 'isLoading'], false)
    }

    case SharedTypes.FETCH_BUSINESS_CATEGORIES_REQUEST: {
      return state.setIn(['businessCategories', 'isLoading'], true)
    }

    case SharedTypes.FETCH_BUSINESS_CATEGORIES_SUCCESS: {
      return state
        .setIn(['businessCategories', 'isLoading'], false)
        .setIn(['businessCategories', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_BUSINESS_CATEGORIES_FAILURE: {
      return state.setIn(['businessCategories', 'isLoading'], false)
    }

    case SharedTypes.FETCH_CONTACTS_REQUEST: {
      return state.setIn(['contacts', 'isLoading'], true)
    }

    case SharedTypes.FETCH_CONTACTS_SUCCESS: {
      return state
        .setIn(['contacts', 'isLoading'], false)
        .setIn(['contacts', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_CONTACTS_FAILURE: {
      return state.setIn(['contacts', 'isLoading'], false)
    }

    case SharedTypes.FETCH_CONTACT_TITLES_REQUEST: {
      return state.setIn(['contactTitles', 'isLoading'], true)
    }

    case SharedTypes.FETCH_CONTACT_TITLES_SUCCESS: {
      return state
        .setIn(['contactTitles', 'isLoading'], false)
        .setIn(['contactTitles', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_CONTACT_TITLES_FAILURE: {
      return state.setIn(['contactTitles', 'isLoading'], false)
    }

    case SharedTypes.FETCH_LAYER_FEATURES_REQUEST: {
      return state.setIn(['layerFeatures', 'isLoading'], true)
    }

    case SharedTypes.FETCH_LAYER_FEATURES_SUCCESS: {
      return state
        .setIn(['layerFeatures', 'isLoading'], false)
        .setIn(['layerFeatures', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_LAYER_FEATURES_FAILURE: {
      return state.setIn(['layerFeatures', 'isLoading'], false)
    }

    case SharedTypes.FETCH_FORMS_REQUEST: {
      return state.setIn(['forms', 'isLoading'], true)
    }

    case SharedTypes.FETCH_FORMS_SUCCESS: {
      return state
        .setIn(['forms', 'isLoading'], false)
        .setIn(['forms', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_FORMS_FAILURE: {
      return state.setIn(['forms', 'isLoading'], false)
    }

    case SharedTypes.FETCH_STATIC_TEMPLATE_REQUEST: {
      return state.setIn(['staticTemplate', 'isLoading'], true)
    }

    case SharedTypes.FETCH_STATIC_TEMPLATE_SUCCESS: {
      return state
        .setIn(['staticTemplate', 'isLoading'], false)
        .setIn(['staticTemplate', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_STATIC_TEMPLATE_FAILURE: {
      return state.setIn(['staticTemplate', 'isLoading'], false)
    }

    case SharedTypes.ACCEPT_TERMS_OF_SERVICE_REQUEST: {
      return state.setIn(['acceptTermsOfService', 'isLoading'], true)
    }

    case SharedTypes.ACCEPT_TERMS_OF_SERVICE_SUCCESS: {
      return state
        .setIn(['acceptTermsOfService', 'isLoading'], false)
        .setIn(['acceptTermsOfService', 'data'], fromJS(action.payload))
    }
    case SharedTypes.ACCEPT_TERMS_OF_SERVICE_FAILURE: {
      return state.setIn(['acceptTermsOfService', 'isLoading'], false)
    }

    case SharedTypes.FETCH_MOBILE_TASK_TYPES_REQUEST: {
      return state.setIn(['mobileTaskTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_MOBILE_TASK_TYPES_SUCCESS: {
      return state
        .setIn(['mobileTaskTypes', 'isLoading'], false)
        .setIn(['mobileTaskTypes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_MOBILE_TASK_TYPES_FAILURE: {
      return state.setIn(['mobileTaskTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_TEMPLATE_TYPES_REQUEST: {
      return state.setIn(['templateTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_TEMPLATE_TYPES_SUCCESS: {
      return state
        .setIn(['templateTypes', 'isLoading'], false)
        .setIn(['templateTypes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_TEMPLATE_TYPES_FAILURE: {
      return state.setIn(['templateTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_AUDIT_LOG_TYPES_REQUEST: {
      return state.setIn(['auditLogTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_AUDIT_LOG_TYPES_SUCCESS: {
      return state
        .setIn(['auditLogTypes', 'isLoading'], false)
        .setIn(['auditLogTypes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_AUDIT_LOG_TYPES_FAILURE: {
      return state.setIn(['auditLogTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_PROPERTY_TYPES_BY_CODE_REQUEST: {
      return state.setIn(['propertyTypesByCode', 'isLoading'], true)
    }

    case SharedTypes.FETCH_PROPERTY_TYPES_BY_CODE_SUCCESS: {
      return state
        .setIn(['propertyTypesByCode', 'isLoading'], false)
        .setIn(['propertyTypesByCode', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_PROPERTY_TYPES_BY_CODE_FAILURE: {
      return state.setIn(['propertyTypesByCode', 'isLoading'], false)
    }

    case SharedTypes.FETCH_LICENSE_TYPES_REQUEST: {
      return state.setIn(['licenseTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_LICENSE_TYPES_SUCCESS: {
      return state
        .setIn(['licenseTypes', 'isLoading'], false)
        .setIn(['licenseTypes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_LICENSE_TYPES_FAILURE: {
      return state.setIn(['licenseTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_PROPERTY_TYPES_REQUEST: {
      return state.setIn(['propertyTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_PROPERTY_TYPES_SUCCESS: {
      return state
        .setIn(['propertyTypes', 'isLoading'], false)
        .setIn(['propertyTypes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_PROPERTY_TYPES_FAILURE: {
      return state.setIn(['propertyTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_MOBILE_USER_MODES_REQUEST: {
      return state.setIn(['mobileUserModes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_MOBILE_USER_MODES_SUCCESS: {
      return state
        .setIn(['mobileUserModes', 'isLoading'], false)
        .setIn(['mobileUserModes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_MOBILE_USER_MODES_FAILURE: {
      return state.setIn(['mobileUserModes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_POSTPROCESSOR_SLOT_TYPES_REQUEST: {
      return state.setIn(['postprocessorSlotTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_POSTPROCESSOR_SLOT_TYPES_SUCCESS: {
      return state
        .setIn(['postprocessorSlotTypes', 'isLoading'], false)
        .setIn(['postprocessorSlotTypes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_POSTPROCESSOR_SLOT_TYPES_FAILURE: {
      return state.setIn(['postprocessorSlotTypes', 'isLoading'], false)
    }

    case SharedTypes.FETCH_DOCUMENT_TYPES_REQUEST: {
      return state.setIn(['documentTypes', 'isLoading'], true)
    }

    case SharedTypes.FETCH_DOCUMENT_TYPES_SUCCESS: {
      return state
        .setIn(['documentTypes', 'isLoading'], false)
        .setIn(['documentTypes', 'data'], fromJS(action.payload))
    }
    case SharedTypes.FETCH_DOCUMENT_TYPES_FAILURE: {
      return state.setIn(['documentTypes', 'isLoading'], false)
    }

    // case SharedTypes.UPDATE_FIELD:
    //   let fields = [];

    //   if (action.path === '') {
    //     fields = action.field.split('.');
    //   } else {
    //     fields = action.path
    //       .split('.')
    //       .concat(action.field.split('.'));
    //   }
    //   const value = action.value;

    //   if (fields.length === 1) {
    //     return state.set(fields[0], fromJS(value));
    //   }
    //   return state.setIn(fields, fromJS(value));
    case SharedTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
